module.exports = {"530114001":"龙城街道","530114002":"洛龙街道","530114003":"斗南街道","530114004":"乌龙街道","530114005":"吴家营街道","530114006":"雨花街道","530114007":"七甸街道","530114008":"洛羊街道","530114009":"大渔街道","530114010":"马金铺街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530114.json
// module id = 2677
// module chunks = 0